module.exports = __webpack_public_path__ + "static/media/halter.a5df4571.png";